import { type BookmarksEpicPriorityListAttributes } from './generated/BookmarksEpicPriorityListAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';
import Epic from './Epic';
import { HasBookmarksPriorityList } from './concerns/HasBookmarksPriorityList';
import Workflow from './Workflow';
import Project from './Project';

interface BookmarksEpicPriorityList
  extends BookmarksEpicPriorityListAttributes,
    HasBookmarksPriorityList {}

@model
@HasBookmarksPriorityList
class BookmarksEpicPriorityList extends ApplicationModel {
  // Start auto-generated
  static typename: 'BookmarksEpicPriorityList' = 'BookmarksEpicPriorityList';
  get typename(): 'BookmarksEpicPriorityList' {
    return 'BookmarksEpicPriorityList';
  }

  static internalTypename: 'Bookmarks::EpicPriorityList' =
    'Bookmarks::EpicPriorityList';
  get internalTypename(): 'Bookmarks::EpicPriorityList' {
    return 'Bookmarks::EpicPriorityList';
  }

  static bookmarkName = 'Bookmarks::EpicPriorityList';

  static inputType = 'PriorityListAttributes!';

  static fields = {
    advancedFilters: attr({ readable: true }),
    advancedFiltersParsed: attr({ readable: true, json: true }),
    clearFilters: attr({ writable: true, readable: false }),
    columnTables: attr({ readable: true, json: true }),
    filters: attr({ readable: true }),
    hasShippableRecords: attr({ readable: true }),
    id: attr({ readable: true }),
    joins: attr({ readable: true, json: true }),
    projectId: attr({ readable: true }),
    totalPrioritizedRecords: attr({ readable: true }),
    totalUnprioritizedRecords: attr({ readable: true }),
    userAllowedToPublishRanks: attr({ readable: true }),
    cardLayout: attr.belongsTo({ readable: true, typename: 'CardLayout' }),
    defaultCardLayout: attr.belongsTo({
      readable: true,
      typename: 'CardLayout',
    }),
    lastPublishedField: attr.belongsTo({
      readable: true,
      typename: 'CustomFieldDefinition',
    }),
    prioritizedRow: attr.belongsTo({ readable: true, typename: 'PivotRow' }),
    prioritizedRows: attr.belongsTo({
      args: { page: 'Int', per: 'Int' },
      readable: true,
      typename: 'PivotRowPage',
    }),
    project: attr.belongsTo({ readable: true, typename: 'Project' }),
    columnWidths: attr.hasMany({ writable: true, readable: true }),
    columns: attr.hasMany({ writable: true, readable: true }),
    lineBreaks: attr.hasMany({ writable: true, readable: true }),
    publishableCustomFields: attr.hasMany({ readable: true }),
    scoringSystemMetrics: attr.hasMany({ readable: true }),
    unprioritizedRecords: attr.hasMany({ readable: true }),
  };
  // End auto-generated

  static get updateFragmentName() {
    return 'updateBookmarksEpicPriorityList';
  }

  static get bookmarkType() {
    return 'Bookmarks::EpicPriorityList';
  }

  static get recordType() {
    return Epic;
  }

  get cardView() {
    return this.cardLayout.epicRecordLayout.expanded;
  }

  static async getWorkflowsForProjects(projectIds: string[]) {
    return Project.select('id')
      .merge({
        epicWorkflow: Workflow.select(['id', 'transitionsOnly']).merge({
          workflowStatuses: [
            'id',
            'name',
            'position',
            'color',
            'internalMeaning',
          ],
        }),
        initiativeWorkflow: Workflow.select(['id', 'transitionsOnly']).merge({
          workflowStatuses: [
            'id',
            'name',
            'position',
            'color',
            'internalMeaning',
          ],
        }),
      })
      .where({ id: projectIds })
      .all();
  }
}

export default BookmarksEpicPriorityList;
